import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { LeadFormComponent } from '../../shared/components/lead-form/lead-form.component';
import { DataFlowService } from '../../shared/services/data-flow.service';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  tfn: any = '';
  leadSource: any = 'Comcast Branded';
  affiliateID: any = '';
  campaignID: any = '';
  ezAgent: any = '';
  secondaryLeadSource: any = '';
  pageSource: any = '';

  constructor(private titleService: Title, private modalService: NgbModal, private dataservice: DataFlowService,) { }

  ngOnInit(): void {
    this.titleService.setTitle("Comcast Business Savings");

    this.tfn = localStorage.getItem('tfn') ? localStorage.getItem('tfn') : this.dataservice.CallTFN
    this.campaignID = localStorage.getItem('campaignID') ? localStorage.getItem('campaignID') : this.campaignID
    this.secondaryLeadSource = localStorage.getItem('secondaryLeadSource') ? localStorage.getItem('secondaryLeadSource') : this.secondaryLeadSource
  }

  openModal() {
    const modalRef = this.modalService.open(LeadFormComponent, { size: 'lg' });
    modalRef.componentInstance.isModal = true;
  }

  open(content:any) {
    this.modalService.open(content, {size: 'lg', ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
    
    }, (reason) => {
    
    });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
}
